const formatApiResponse = require('./format-api-response');

function optionsError(options, error) {
  if (options && options.error) {
    if (typeof error === 'string') {
      options.error(new Error(error));
    } else if (error instanceof Error) {
      options.error(error);
    } else if (error && error.error && error.error.messages) { // api error response
      options.error(new Error(formatApiResponse(error.error)));
    } else if (error && error.messages) { // api error
      options.error(new Error(formatApiResponse(error)));
    } else if (error.status) {
      options.error(new Error(`Request failed. response[${formatApiResponse(error)}] status[${error.status}]`));
    } else if (error) { // defined error but unknown type
      options.error(new Error(`Encountered error: ${error.toString()}`));
    } else { // no error provided
      options.error();
    }
  }
}

module.exports = optionsError;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/options-error.js